export const DEFAULT_LOADING_DESCRIPTION = {
  en: [
    'Loading',
    'Good things take a second',
    'Making it worth the wait',
    'Almost there, hang tight',
    'Preparing something great for you'
  ],
  sv: [
    'Laddar',
    'Bra saker tar en liten stund',
    'Vi gör det värt att vänta på',
    'Snart framme, håll ut',
    'Förbereder något riktigt bra åt dig'
  ]
}
